<template>
    <div>
        <img :src=imgSrc style="width: 100%; height: 100%">
        <!-- 
        <img src="../../../../src/main/images/i5gam/popup/popupImg1.png" usemap="#Map1">
        <map name="Map1">
            <area shape="rect" coords="362,533,667,597" href="javascript:;" alt="월 이용료 기준 알아보기" @click="btn_noticeClick">
            <area shape="rect" coords="44,534,358,598" href="javascript:;" alt="결제카드 등록바로가기" @click="btn_myPageClick">
        </map>
        -->
    </div>
</template>

<script>
export default {
    name : 'popup2',
    props: ['index'],
    data: function(){
        return {
            imgSrc:'',
        }
    },
    methods : {
        btn_noticeClick : function(){
            //상세페이지로 이동하기 위해 공지사항 sn 넣어줘야함
            this.$router.push({ name: 'views.i5gam.cs.cs', params : {sn : 343}});
            //this.$router.push({ name: 'views.i5gam.cs.cs'});
            
            this.$store.commit('closePopup', this.index);
            this.$store.commit('closePopup');
        },
        btn_myPageClick : function(){
            if(!this.loginAt){
                this.$toasted.show('로그인해주세요.');
                this.$store.commit('closePopup');
                return false;
            }

            this.$router.push({ name: 'views.i5gam.member.myPage'});
            this.$store.commit('closePopup');
        }
    },
    mounted:function(){
        this.imgSrc = '/images/i5gam/popup/popupImg2.png';

    },
    computed : {
        mberInfo : function(){
            return this.$store.getters.getMberInfo;
        },
        loginAt : function(){
            return this.$store.getters.getLoginAt;
        },
    },
}
</script>